import angular, { ILogService } from 'angular'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IMenuNavegacion, IModelMenu, INavegacionForm } from '../../../../model/candidato-api'
import { AccesoDatos } from '../../../comun/services/acceso-datos'

import './panel-menu.scss'

class PanelMenuComponentCtrl {
  list: IMenuNavegacion[]
  formulars: INavegacionForm[]

  constructor(
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    let $menuResource = this.AccesoDatos.menuResource

    // $menuResource.findAll().then(listResponse => this.list = listResponse)

    this.AccesoDatos.GestionMenu_CLIENT.menusNavegacion().then((response) => {
      this.list = response.root

      // gestionarn los formularios
      this.formulars = response.formularios
    })
  }

  nuevoPrincipal() {
    let _nuevo = {} as IMenuNavegacion

    _nuevo.m = {} as IModelMenu

    _nuevo.m.idmensuper = null

    this.list.push(_nuevo)

    _scrollBottom()
  }
}

angular.module('candidato').component('panelMenu', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelMenuComponentCtrl,
  template: require('./panel-menu.component.html'),
  //templateUrl: "../../../../app/ui/vs/prog/dev/templates/panel-menu/panel-menu.component.html"
})

function _scrollBottom() {
  // scroll bottom
  var a = $('.container-fluid')

  if (a && a.length) {
    var _el = a[0]

    setTimeout(() => _el.scroll({ behavior: 'smooth', top: _el.scrollHeight + 10000 }), 30)
  }
}
